// import React from "react";
// import "./IncomerFeeder.css";

// export default function IncomerFeeder() {
//   const Feeder = ({ name }) => (
//     <div className="feeder">
//       <div className="line-vertical"></div>
//       <div className="box"></div>
//       <div className="feeder-label">{name}</div>
//     </div>
//   );

//   const Section = ({ feederCount }) => (
//     <div className="section">
//       <div className="bus"></div>
//       <div className="feeders">
//         {Array.from({ length: feederCount }).map((_, i) => (
//           <Feeder key={i} name={`Feeder${i + 1}`} />
//         ))}
//       </div>
//     </div>
//   );

//   const Incomer = ({ title, sections, feederCount }) => (
//     <div className="incomer">
//       <div className="incomer-title">{title}</div>

//       <div className="incomer-line">
//         <div className="box"></div>
//       </div>

//       <div className="sections">
//         {Array.from({ length: sections }).map((_, i) => (
//           <Section key={i} feederCount={feederCount} />
//         ))}
//       </div>
//     </div>
//   );

//   return (
//     <div className="sld-container">
//       {/* Left */}
//       <Incomer title="Incomer 1" sections={3} feederCount={6} />

//       {/* Center Bus Coupler */}
//       <div className="bus-coupler">
//         <div className="box"></div>
//         <div className="label">BS1-2</div>
//       </div>

//       {/* Right */}
//       <Incomer title="Incomer 2" sections={3} feederCount={5} />
//     </div>
//   );
// }


// 2./

import React from "react";
import "./IncomerFeeder.css";
import TopHeader from "../../../../components/general/TopHeader";

/* ---------- Small Components ---------- */

const Feeder = ({ name }) => {
  return (
    <div className="feeder">
      <div className="line-vertical"></div>
      <div className="box"></div>
      <div className="feeder-label">{name}</div>
    </div>
  );
};

const Section = ({ feederCount }) => {
  return (
    <div className="section">
      <div className="bus"></div>
      <div className="feeders">
        {Array.from({ length: feederCount }, (_, i) => (
          <Feeder key={i} name={`FDR-${i + 1}`} />
        ))}
      </div>
    </div>
  );
};

const Incomer = ({ title, sections, feederCount }) => {
  return (
    <div className="incomer">
      <div className="incomer-title">{title}</div>

      <div className="incomer-line">
        <div className="box"></div>
      </div>

      <div className="sections">
        {Array.from({ length: sections }, (_, i) => (
          <Section key={i} feederCount={feederCount} />
        ))}
      </div>
    </div>
  );
};

/* ---------- Main Page ---------- */

export default function IncomerFeeder() {
  return (
    <>
    <TopHeader/>
     <div className="sld-page">
      <h2 className="page-title">Incomer Diagram</h2>

      <div className="sld-wrapper">
        <div className="sld-container">
          {/* Left Side */}
          <Incomer title="Incomer 1" sections={3} feederCount={6} />

          {/* Bus Coupler */}
          <div className="bus-coupler">
            <div className="box"></div>
            <div className="label">BS1-2</div>
          </div>

          {/* Right Side */}
          <Incomer title="Incomer 2" sections={3} feederCount={5} />
        </div>
      </div>
    </div>
    </>
   
  );
}